import { routeLinks } from "constants/paths";
import { useGlobalContext } from "context/GlobalContext";
import { useModuleAccessNavContext } from "context/ModuleAccessNavContext";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { decodeAccessLevelCode } from "utils/decodeAccessLevelCode";

export const SetPageAccessRoutesForProjectManagement = () => {
  const { accessCodeMap } = useModuleAccessNavContext();
  const [shouldRedirect, setShouldRedirect] = useState(true);
  const { isInitializing, isLoading, setPageAccess } = useGlobalContext();
  const location = useLocation();
  const { subModuleAccess } = useSelector((state) => state.roles.state);

  useEffect(() => {
    if (!isInitializing && !isLoading) {
      const currentPageAccessCode =
        accessCodeMap[routeLinks.projectManagementProject];
      if (!subModuleAccess[currentPageAccessCode]) {
        setShouldRedirect(false);
        return;
      }
      const accessLevel = decodeAccessLevelCode(
        subModuleAccess[currentPageAccessCode]
      );

      setPageAccess(accessLevel);

      setShouldRedirect(true);
    }
  }, [location.pathname, isInitializing]);
  if (shouldRedirect) {
    return <Outlet />;
  } else {
    return <Navigate to="/" />;
  }
};
